import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewThreeColumnsComponent } from "./med-icon-view-three-columns.component";

@NgModule({
  declarations: [
    MedIconViewThreeColumnsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewThreeColumnsComponent,
  ],
})
export class MedIconViewThreeColumnsModule { }
